import { startOfDay, startOfHour, subDays, subHours } from 'date-fns'
import { AssetType, AxiomaW1AlarmCode, AxiomaW1NominalDiameter } from '../enums'
import {
  AssetStatus,
  AxiomaW1,
  AxiomaW1Alarm,
  AxiomaW1AlarmQuery,
  AxiomaW1Telemetry,
  AxiomaW1TelemetryQuery,
  AxiomaW1Volume,
  AxiomaW1VolumeQuery
} from '../types'
import { AxiosRequestConfig } from 'axios'

const axioma_w1: Record<string, AxiomaW1> = {
  '12345678': {
    id: '12345678',
    asset: {
      id: '12345678',
      name: 'Mock vesimittari',
      description: null,
      type: AssetType.AXIOMA_W1,
      status: AssetStatus.ACTIVE,
      companyId: null,
      projectId: null,
      levelId: null,
      liftId: null,
      groupId: null,
      deviceName: null,
      ruuviTagId: null,
      auroraId: null,
      photoId: null,
      axiomaW1Id: '123456',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      deletedAt: null
    },
    asset_id: '123456',
    sim_id: '987654321',
    nominal_diameter: AxiomaW1NominalDiameter.DN40,
    production_batch: '2026.1234567890',
    catalog_product: null,
    catalog_product_id: null,
    product: null,
    product_id: null,
    is_virtual: false,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  }
}

let baselineVolume = Math.random() * 100

const batteryVoltage = Math.random() * 5 + 3

const batteryPercentage = Math.floor(Math.random() * 99) + 1

const axioma_w1_telemetry: AxiomaW1Telemetry[] = Array.from({ length: 30 }, (_, i) => {
  const flow = Math.random() * 0.1
  const volume = baselineVolume - 24 * (Math.random() * 0.01)
  baselineVolume = volume
  return {
    time: startOfDay(subDays(new Date(), i)).toISOString(),
    axioma_w1_id: '123456',
    ssc: '*:*:*:axioma:123456',
    version: '1.0.0',
    sim_id: '987654321',
    volume,
    flow,
    temperature: Math.random() * 30,
    signal_rssi: Math.floor(Math.random() * 100) - 100,
    signal_rsrq: Math.floor(Math.random() * 20) - 20,
    signal_ecl: Math.floor(Math.random() * 7),
    signal_band: Math.floor(Math.random() * 100),
    modem_tx_time: Math.floor(Math.random() * 1000),
    modem_rx_time: Math.floor(Math.random() * 1000),
    modem_active_duration: Math.floor(Math.random() * 2000),
    modem_credits: Math.floor(Math.random() * 100),
    modem_status: Math.floor(Math.random() * 5),
    battery_voltage: batteryVoltage - (30 - i) * 0.1,
    battery_percentage: batteryPercentage,
    firmware_version: '1.0.0',
    errors: [],
    alarm_time: null,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  }
})

const axioma_w1_volume: AxiomaW1Volume[] = Array.from({ length: 24 * 30 }, (_, i) => ({
  time: startOfHour(subHours(new Date(), i)).toISOString(),
  axioma_w1_id: '123456',
  ssc: '*:*:*:axioma:123456',
  volume: Math.random() * 0.01,
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString()
}))

export function getAxiomW1s(_config?: AxiosRequestConfig) {
  return Promise.resolve(Object.values(axioma_w1))
}

export function getAxiomaW1(id: string, _config?: AxiosRequestConfig) {
  const w1 = axioma_w1[id]
  if (!w1) {
    return Promise.reject(new Error('Axioma W1 not found'))
  }
  return Promise.resolve(w1)
}

export function getAxiomaW1Telemetries(
  axioma_w1_id: string,
  _query: AxiomaW1TelemetryQuery,
  _config?: AxiosRequestConfig
) {
  return Promise.resolve(axioma_w1_telemetry.filter((t) => t.axioma_w1_id === axioma_w1_id))
}

export function getAxiomaW1Telemetry(_id: string, _config?: AxiosRequestConfig) {
  return Promise.resolve(axioma_w1_telemetry[0])
}

export function getAxiomaW1Volumes(
  id: string,
  query: AxiomaW1VolumeQuery,
  _config?: AxiosRequestConfig
) {
  return Promise.resolve(
    axioma_w1_volume
      .filter((v) => new Date(v.time) >= query.from && new Date(v.time) <= query.to)
      .map((v) => ({
        ...v,
        axioma_w1_id: id
      }))
  )
}

export function getAxiomaW1Alarms(
  id: string,
  query: AxiomaW1AlarmQuery,
  _config?: AxiosRequestConfig
): Promise<AxiomaW1Alarm[]> {
  const alarmCodes = Object.values(AxiomaW1AlarmCode).filter(() => Math.random() < 0.3)

  return Promise.resolve(
    Array.from({ length: 24 * 30 }, (_, i) => {
      return {
        axiomaW1Id: id,
        time: startOfHour(subHours(new Date(), i)).toISOString(),
        errorCode: alarmCodes[Math.floor(Math.random() * alarmCodes.length)],
        ssc: 'example:ssc'
      }
    }).filter((alarm) => new Date(alarm.time) >= query.from && new Date(alarm.time) <= query.to)
  )
}

export function getAxiomaW1ActiveAlarms(
  id: string,
  _config?: AxiosRequestConfig
): Promise<AxiomaW1Alarm[]> {
  const alarmCodes = Object.values(AxiomaW1AlarmCode).filter(() => Math.random() < 0.3)

  return Promise.resolve(
    alarmCodes.map((errorCode) => ({
      time: new Date().toISOString(),
      errorCode,
      axiomaW1Id: id,
      ssc: 'example:ssc'
    }))
  )
}
